<script>
    import {onDestroy} from 'svelte';
    import { notificationStore } from './notification-store.js';

    let message = '';
    let type = 'error';
    let duration = 3000;
    let timeout;

    const unsubscribe = notificationStore.subscribe(state => {
        message = state.message;
        type = state.type;
        duration = state.duration;
    });

    function show() {
        clearTimeout(timeout);
        timeout = setTimeout(() => { hide(); }, duration);
    }

    function hide() {
        notificationStore.set({ message: '', type: 'error', duration: 3000 });
    }

    $: if (message) {
        show();
    }

    onDestroy(() => {
        clearTimeout(timeout);
        unsubscribe();
    });
</script>

<style>
    .notification {
        position: fixed;
        top: 1rem;
        right: 1rem;
        padding: .85rem 1rem;
        border-radius: 0.15rem;
        background-color: var(--accent-color);
        color: var(--bg-color);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
        z-index: 100000;
        max-width: 300px;
        animation: slide-in 0.3s ease-out;
        font-weight: 400;
        font-size: .9rem;
    }

    .notification.error {
        border-left: 4px solid #ff4444;
    }

    .notification.success {
        border-left: 4px solid #00C851;
    }

    @keyframes slide-in {
        from {
            transform: translateX(100%);
            opacity: 0;
        }
        to {
            transform: translateX(0);
            opacity: 1;
        }
    }
</style>

{#if message}
    <div class="notification {type}" on:click={hide}>
        {message}
    </div>
{/if} 
